module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp3",
    attrs: {
      "id": "photo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-head"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Photography")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text-fl-1"
  }, [_vm._v("This book includes forty previously unseen photographs from Dennis Morris, Lena Kagg Ferrero and Sue Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text"
  }, [_vm._v("Dennis Morris shot to fame as a teenager photographing Bob Marley between 1973 and 1981, before taking iconic shots of John Lydon and the Sex Pistols. In 1985 Martin Hannett, then producing The Stone Roses, tried to convince the band to collaborate with Morris to develop their ‘look’ – a plan that was abandoned when Morris and John Squire didn’t hit it off. But Ian Brown and Reni kept in contact with him. The photographs in this book were taken during informal sessions from 1989 to 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text"
  }, [_vm._v("Lena Kagg Ferrero followed the Roses on their 1985 tour of Sweden with Toxin Toy. Her photographs of the Roses had been stored for more than twenty-five years in the loft of her father’s house. They are the rarest early shots of the band.")]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text"
  }, [_vm._v("Sue Dean was a well-known face on the Manchester scene in the 1980s, and for a couple of years was the girlfriend of the Roses’ manager Gareth Evans. She was the only photographer to capture the Roses consistently throughout their lost years of 1986 and 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text"
  }, [_vm._v("The never-seen-before ephemera from this period was supplied from the archives of Howard Jones, manager of The Stone Roses from 1984 to 1986. Producer John Leckie also supplied private paperwork, as did Jive/Zomba’s Steven Howard.")]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered-first"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr1#ph1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.   Garner, Brown and Couzens on tour bus, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr2#ph2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.   Squire, Brown, Garner, Reni and Jones on tour bus, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr3#ph3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.   Couzens and Brown on stage, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr4#ph4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.   Squire and Garner on stage, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr5#ph5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.   Couzens, Brown, Squire and Garner on stage, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr6#ph6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.   Couzens, Brown, Reni and Squire on stage, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr7#ph7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.   Reni and Brown on stage, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr8#ph8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.   Thin Line advert for 1985 Swedish tour. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr9#ph9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.   Garner, Reni, Brown and Squire on tour, Sweden, 1985 © Lena Kagg Ferrero.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr10#ph10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  Thin Line press release for ‘So Young’/‘Tell Me’, 1985, p.1. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr10#ph11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  Thin Line press release for ‘So Young’/‘Tell Me’, 1985, p.2. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr11#ph12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.  Thin Line advert, 1985. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr12#ph13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.  Thin Line advert for ‘So Young’/‘Tell Me’, 1985. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr13#ph14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.  ‘So Young’/‘Tell Me’ single label detail, 1985. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr14#ph15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.  Ticket for Warehouse 1, 1985. Courtesy of Howard Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr15#ph16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.  The Patrol, 1980 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr16#ph17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.  Squire, Brown and Garner in rehearsal, 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr17#ph18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.  Brown in rehearsal, 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr18#ph19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.  Squire, Garner and Brown on stage, 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr19#ph20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.  Brown on stage, 1986 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr20#ph21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.  Reni on stage, 1986 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr21#ph22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.  Reni on stage, 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr22#ph23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.  Brown and his tattoo, 1988 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr23#ph24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.  Mani in 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr24#ph25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.  The Roses at Warehouse 2, 1985 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr25#ph26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.  Mani, John Leckie and Brown outside the International II, 1988 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr26#ph27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.  Mani, Gareth Evans and Tim Booth outside the International II, 1988 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr27#ph28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.  Garner, Squire, Reni and Brown signing the contract, 1987 © Sue Dean.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr28#ph29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.  Band contact list. Courtesy of Steven Howard.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr29#ph30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.  Mani, Brown, Squire and Reni studio shot, 1989 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr30#ph31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.  Reni, Squire, Mani and Brown studio shot, 1989 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr31#ph32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.  Fax from John Leckie, p. 1. Courtesy of John Leckie.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr31#ph33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.  Fax from John Leckie, p. 2. Courtesy of John Leckie.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr32#ph34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.  Fans at Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr33#ph35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.  Dressing room at Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr34#ph36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.  Crowd shot, Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr35#ph37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.  Squire and Brown on stage, Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr36#ph38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.  Brown on stage, Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr37#ph39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.  Brown on stage, Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr38#ph40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.  Squire on stage, Glasgow Green, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr39#ph41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.  Reni on stage, Glasgow Green, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr40#ph42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.  Brown on stage, Spike Island, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr41#ph43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.  Glasgow Green, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr42#ph44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.  Cressa, Brown and Reni on stage, Glasgow Green, 1990 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr43#ph45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.  Reni, Mani, Squire and Brown on stairwell, Dennis Morris’s studio, 1994 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr44#ph46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.  John Leckie’s post-resignation fax, p. 1. Courtesy of John Leckie.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr44#ph47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.  John Leckie’s post-resignation fax, p. 2. Courtesy of John Leckie.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr45#ph48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.  Brown in Morris’s studio, 1994 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr46#ph49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49.  Mani in Morris’s studio, 1994 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr47#ph50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50.  Squire in Morris’s studio, 1994 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr48#ph51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51.  Reni in Morris’s studio, 1994 © Dennis Morris.")])]), _vm._v(" "), _c('p', {
    staticClass: "x07-list-numbered-last"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr49#ph52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.  The band in Morris’s studio, 1994 © Dennis Morris.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1307ecbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/photo.vue
// module id = 75
// module chunks = 0